import { useContext } from 'react';
import { PropertyPreviewVisibilityContext } from '../../contexts/property-preview-visibility-context';

/**
 * Reads whether a mounted card is still part of an expanded, active view.
 * @returns The combined parent and column visibility gate.
 */
export const usePropertyPreviewVisibilityScope = (): boolean =>
  useContext(PropertyPreviewVisibilityContext);
